module.exports = __webpack_public_path__ + "img/16.162aa0b2.png";